export const CHAIN_PROPERTIES = {
  ss58Format: 126,
  tokenDecimals: [10],
  tokenSymbol: ['JOY'],
} as const
